import { render, staticRenderFns } from "./AddCourseByShop.vue?vue&type=template&id=208a2b08&scoped=true&"
import script from "./AddCourseByShop.vue?vue&type=script&lang=js&"
export * from "./AddCourseByShop.vue?vue&type=script&lang=js&"
import style0 from "./AddCourseByShop.vue?vue&type=style&index=0&id=208a2b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a2b08",
  null
  
)

export default component.exports